import ScoreChart from 'designer/component/element/ScoreChart'

const ScoreChartControl = (props) => {
  return <ScoreChart {...props} />
}

export default ScoreChartControl
